export default "__VITE_ASSET__BjFcf2Gy__"